// modulos
import { mapState, mapActions, mapGetters } from 'vuex';
// Utils
import { USER_TYPE } from '@/utils/constants';
import { getParameterByName } from '@/utils/';
import HomeMenu from '@/components/home/menu';
import MenuBtn from '@/components/home/menu-btn';
import SupplierBlocked from '@/components/modal/supplier-blocked';
import { HalfCircleSpinner } from 'epic-spinners';
export default {
    name: 'Home',
    components: { HomeMenu, SupplierBlocked, MenuBtn, HalfCircleSpinner },
    data: () => ({
        show: true,
        supplierBlockedModal: false,
        contractorProfiles: [
            {
                description:
                    'Este perfil permite criar cotações para atender demandas de produtos, serviços e equipamentos.',
                icon: 'user-friends',
                title: 'Construção civil',
                type: USER_TYPE.CIVIL_CONSTRUCTION,
                visible: true
            },
            {
                description:
                    'Este perfil permite criar cotações para atender demandas de produtos, serviços e equipamentos.',
                icon: 'city',
                title: 'Condomínio',
                type: USER_TYPE.CONDOMINUM,
                visible: true
            },
            {
                description:
                    'Este perfil permite criar cotações para atender demandas de produtos, serviços e equipamentos.',
                icon: 'user',
                title: 'Sou empresa ou Cliente Engelink',
                type: USER_TYPE.RENOVATION_AND_SERVICES,
                visible: true
            }
        ],
        supplierProfiles: [
            {
                description: 'Este perfil permite receber convites para participação em cotações e envio de propostas.',
                icon: 'reply-all',
                title: 'Fornecedor',
                type: USER_TYPE.SUPPLIER,
                visible: true
            }
        ],
        loading: true
    }),
    async created () {
        this.loading = true;
        try {
            if (
                !getParameterByName('redirect') &&
                (this.hasContractorProfile || (this.isSupplierValidated && !this.isSubscriptionDefault))
            ) {
                // se ele é contratante ou supplier válido, terminou o cadastro e NãO tem o parametro para redirecionar
                // verificar se ele tem mais de um perfil
                // se sim, manter ele na tela de inicio para selecionar perfil
                // se não redireciona ele pra sua tela do seu usuário
                if (!this.hasContractorProfile || !this.isSupplierValidated) {
                    this.redirectPostLogin();
                } else {
                    this.loading = false;
                }
            } else if (this.isSupplier && !this.isSupplierValidated) {
                // se ele é um supplier inválido
                this.supplierBlockedModal = true;
                this.loading = false;
            } else if (this.isSupplier && this.isSubscriptionDefault) {
                this.redirectPostLogin();
            } else {
                this.loading = false;
            }
        }
        catch (e) {
            console.error(e)
        } finally {
            this.loading = false;
        }
    },
    methods: {
        ...mapActions('signup', ['setSignupType']),
        ...mapGetters('signup', ['getTypeSignup']),
        checkProfileExistence (profileType) {
            switch (profileType) {
            case USER_TYPE.CONDOMINUM || USER_TYPE.PROFESSIONAL_BUILDING_MANAGER:
                this.checkCondominumExistence();
                break;
            case USER_TYPE.CIVIL_CONSTRUCTION:
                this.checkCivilConstructionExistence();
                break;
            case USER_TYPE.SUPPLIER:
                if (!this.isSupplierValidated && this.user.type.isSupplier) {
                    this.supplierBlockedModal = true;
                } else {
                    this.checkSupplierExistence();
                }
                break;
            case USER_TYPE.RENOVATION_AND_SERVICES || USER_TYPE.CORPORATIVE || USER_TYPE.PRIVATE_PERSON:
                this.checkRenovationAndServicesExistence();
                break;
            }
        },
        checkCivilConstructionExistence () {
            this.setSignupType('contractor');
            if (this.hasContractorProfile && [USER_TYPE.CIVIL_CONSTRUCTION].includes(this.contractorProfile)) {
                this.$router.push({ name: 'ListCompetitions' });
            } else {
                this.$router.push({ name: 'SignupForm' });
            }
        },
        checkCondominumExistence () {
            this.setSignupType('condominum');
            if (
                this.hasContractorProfile &&
                [USER_TYPE.CONDOMINUM, USER_TYPE.PROFESSIONAL_BUILDING_MANAGER].includes(this.contractorProfile)
            ) {
                this.$router.push({ name: 'ListCompetitions' });
            } else {
                this.$router.push({ name: 'SignupForm' });
            }
        },
        checkRenovationAndServicesExistence () {
            this.setSignupType('physical-person');
            if (
                this.hasContractorProfile &&
                [USER_TYPE.RENOVATION_AND_SERVICES, USER_TYPE.CORPORATIVE, USER_TYPE.PRIVATE_PERSON].includes(
                    this.contractorProfile
                )
            ) {
                this.$router.push({ name: 'ListCompetitions' });
            } else {
                this.$router.push({ name: 'SignupForm' });
            }
        },
        checkSupplierExistence () {
            this.setSignupType('supplier');
            if (this.isSupplierValidated) {
                if (this.hasSubscription) {
                    this.$router.push({ name: 'CompetitionDashboard' });
                } else {
                    this.$router.push({ name: 'CompetitionDashboard' });
                }
            } else {
                this.$router.push({ name: 'SignupForm' });
            }
        },
        redirectPostLogin () {
            if (this.hasContractorProfile && !this.isSupplierValidated) {
                switch (this.contractorProfile) {
                case USER_TYPE.CONDOMINUM:
                    this.setSignupType('condominum');
                    this.$router.push({ name: 'ListCompetitions' });
                    break;
                case USER_TYPE.PROFESSIONAL_BUILDING_MANAGER:
                    this.setSignupType('condominum');
                    this.$router.push({ name: 'ListCompetitions' });
                    break;
                case USER_TYPE.CIVIL_CONSTRUCTION:
                    this.setSignupType('contractor');
                    this.$router.push({ name: 'ListCompetitions' });
                    break;
                case USER_TYPE.RENOVATION_AND_SERVICES:
                    this.setSignupType('physical-person');
                    this.$router.push({ name: 'ListCompetitions' });
                    break;
                case USER_TYPE.CORPORATIVE:
                    this.setSignupType('physical-person');
                    this.$router.push({ name: 'ListCompetitions' });
                    break;
                case USER_TYPE.PRIVATE_PERSON:
                    this.setSignupType('physical-person');
                    this.$router.push({ name: 'ListCompetitions' });
                    break;
                case USER_TYPE.REQUESTER:
                    this.$router.push({ name: 'ListCompetitions' });
                    break;
                }
            } else if (!this.hasContractorProfile && this.isSupplierValidated) {
                this.setSignupType('supplier');
                // se ele for supplier verificar se tem assinatura se sim HOME DASHBOARD SE Não LISTA DE COTACAÇÔES
                if (this.hasSubscription) {
                    this.$router.push({ name: 'CompetitionDashboard' });
                } else {
                    this.$router.push({ name: 'CompetitionDashboard' });
                }
            }
        }
    },
    computed: {
        ...mapState('user', ['user']),
        contractorProfile () {
            return this.user.type.contractorType;
        },
        hasContractorProfile () {
            return this.user.type.hasContractorProfile;
        },
        hasSubscription () {
            return this.user.type.hasSubscription;
        },
        isSupplier () {
            return this.user.type.isSupplier;
        },
        isSupplierValidated () {
            return this.user.type.isSupplierValidated;
        },
        isSubscriptionDefault () {
            return this.user.type.isSubscriptionDefault;
        }
    }
};
